import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, insideImages } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(Math.max(0, Math.min(insideImages.length - 1, i)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-86" data-mp="a2o3oog3rxft">
      <div className="mx-auto max-w-2xl" data-id="element-87" data-mp="a1394ytsgehy">
        <h2 className="text-center text-[1.2rem] font-extrabold uppercase text-navy sm:text-[1.8rem]" data-id="element-88" data-mp="612v3falq5bf">
          Look inside
        </h2>
        <p className="mt-0.5 text-center text-[0.74rem] font-bold uppercase tracking-wide text-sono sm:text-[0.88rem]" data-id="element-89" data-mp="jzsux2ot2j3h">
          Discover What's Inside ULTRASOUND VISUAL ATLAS™
        </p>
        <p className="mt-1 text-center text-[0.76rem] leading-[1.35] sm:text-[0.9rem]" data-id="element-90" data-mp="3ngsx5mw0zzjb">
          Probe orientation, abdominal anatomy, renal and pelvic ultrasound,
          obstetric and gynecologic references, vascular and soft-tissue
          imaging, normal-versus-abnormal comparisons and structured
          pattern-recognition tools.
        </p>

        <div className="relative mt-2" data-id="element-91" data-mp="3seudw15zbmrm">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto rounded-md border border-navy/10 bg-clinical" role="group" aria-roledescription="carousel" aria-label="Interior pages of Ultrasound Visual Atlas" tabIndex={0} data-id="element-92" data-mp="34qb41h7a71xf">
            {insideImages.map((img, i) => <a key={img.src} href={PURCHASE_ANCHOR} className="w-full shrink-0 snap-center p-2" aria-label={`Page ${i + 1} of ${insideImages.length} — get the complete system`} data-id="element-93" data-mp="1de4ydgnxiby1" data-mpi={i}>
                <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full rounded-sm bg-white shadow-md" data-id="element-94" data-mp="ks2de5ntxug4" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full bg-navy/85 p-1.5 text-white shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-95" data-mp="yrbq2vctu6fc">
            <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="2f9hqb8fn9to2" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full bg-navy/85 p-1.5 text-white shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-97" data-mp="2aij5bvjpo7eh">
            <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="1rjx4mhs3wib3" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-99" data-mp="1niv3twijjy70">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-colors duration-150 ease-out ${i === index ? 'w-5 bg-navy' : 'w-1.5 bg-navy/25'}`} data-id="element-100" data-mp="3lyhmynsyg1rb" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}